export const Path = {
  LOGIN: '/login',
  APP: '/app',
  DASHBOARD: '/app/dashboard',
  SERVICES: '/app/services',
  SERVICES_DETAILS: '/app/services/:id/:repositoryID/:deploymentVersionID',
  PULL_REQUESTS: '/app/pull-requests',
  ISSUES: '/app/issues',
  SECRETS: '/app/secrets',
  SETTINGS: '/app/settings',
  INVITES: '/app/invites',
  ADMIN_USERS: '/app/admin-users',
  ON_BOARDING: '/onboarding',
  GITHUB_AUTH_LOADING: '/github-auth-loading',
  NOT_FOUND_PAGE: '/not-found-page',
  GITHUB_INSTALLATION: '/github-installation',
  WORKFLOWS: '/app/workflows',
  WORKFLOWS_RUN_STEPS: '/app/workflows/:id',
  DEPLOYMENT_VERSIONS: '/app/deployment-versions',
  CONNECTIONS: '/app/connections',
  CLUSTERS: '/app/clusters',
  CLUSTER_DETAILS: '/app/clusters/:id',
};

export const Permission = {
  DASHBOARD: 'dashboard',
  SERVICES: 'services',
  SERVICES_DETAILS: 'services/:id/:repositoryID/:deploymentVersionID',
  PULL_REQUESTS: 'pullRequests',
  ISSUES: 'issues',
  GITHUB_INSTALLATION: 'githubInstallation',
  WORKFLOWS: 'workflows',
  SETTINGS: 'settings',
  USER: 'user',
  SECRETS: 'secrets',
  DEPLOYMENT_VERSIONS: 'deployment-versions',
  CONNECTIONS: 'connections',
  CLUSTERS: 'clusters',
  CLUSTER_DETAILS: 'clusters/:id',
};

export type RoutesPageNames =
  | 'DASHBOARD'
  | 'SERVICES'
  | 'SERVICES_DETAILS'
  | 'PULL_REQUESTS'
  | 'ISSUES'
  | 'GITHUB_INSTALLATION'
  | 'ADMIN_USERS'
  | 'SETTINGS'
  | 'INVITES'
  | 'WORKFLOWS'
  | 'SECRETS'
  | 'DEPLOYMENT_VERSIONS'
  | 'CONNECTIONS'
  | 'CLUSTERS'
  | 'CLUSTER_DETAILS';

export type PageNames = RoutesPageNames;

export const pageNames: Record<PageNames, PageNames> = {
  DASHBOARD: 'DASHBOARD',
  SERVICES: 'SERVICES',
  SERVICES_DETAILS: 'SERVICES_DETAILS',
  PULL_REQUESTS: 'PULL_REQUESTS',
  ISSUES: 'ISSUES',
  GITHUB_INSTALLATION: 'GITHUB_INSTALLATION',
  ADMIN_USERS: 'ADMIN_USERS',
  SETTINGS: 'SETTINGS',
  INVITES: 'INVITES',
  WORKFLOWS: 'WORKFLOWS',
  SECRETS: 'SECRETS',
  DEPLOYMENT_VERSIONS: 'DEPLOYMENT_VERSIONS',
  CONNECTIONS: 'CONNECTIONS',
  CLUSTERS: 'CLUSTERS',
  CLUSTER_DETAILS: 'CLUSTER_DETAILS',
};

export const unsafe_experimental_features = 'unsafe_experimental_features';
